module.exports = __webpack_public_path__ + "img/2025-5.21a6826b.jpg";